<template>
  <k-page class="page-points">
    <div class="page-points__controls">
      <el-tooltip content="Обновить данные" placement="top">
        <el-button @click="handleRefresh()" type="primary" icon="el-icon-refresh-left" circle size="mini" :loading="isPointsLoading"></el-button>
      </el-tooltip>

      <el-tooltip content="Добавить акцию" placement="top">
        <el-button @click="handleAdd()" type="success" icon="el-icon-plus" circle size="mini"></el-button>
      </el-tooltip>
    </div>

    <!-- <div class="page-points__filter">
      <el-radio v-model="actionsFilter" label="all">Все места</el-radio>
      <el-radio v-model="actionsFilter" label="active">Действующие акции</el-radio>
    </div> -->

    <k-points-list
      :points="points"
      @edit="setPoint"
      @delete="deletePoint"
    />
    <k-point-edit-form
      :dialogFormVisible="activePoint !== '' || creatigNew"
      :point="point"
      @cancel="handleCancel"
    />
  </k-page>
</template>

<script>
/**
 * Page: Страница редактирования акций
 *
 * @version 1.0.0
 */


import { mapGetters, mapActions } from 'vuex';


// Components
import KPage from '@/components/KPage.vue';
import KPointEditForm from '@/components/KPointEditForm.vue';
import KPointsList from '@/components/KPointsList.vue';


export default {
  name: 'page-points',

  data() {
    return {
      activePoint: '',
      creatigNew: false,
      actionsFilter: 'active',
    };
  },

  computed: {
    point() {
      const point = this.points.find(item => item._id === this.activePoint);

      return this.creatigNew || !point
        ? {}
        : point;
    },

    points() {
      // return this.actionsFilter === 'all'
      //   ? this.allPoints
      //   : this.activePoints;

      return this.allPoints;
    },

    ...mapGetters({
      isPointsLoading: 'points/isPointsLoading',
      allPoints: 'points/points',
      activePoints: 'points/activePoints',
    }),
  },

  async created() {
    await this.getPoints();
  },

  methods: {
    setPoint(id) {
      this.activePoint = id;
    },

    handleCancel() {
      this.creatigNew = false;
      this.activePoint = '';
    },

    async deletePoint(id) {
      console.log('deletePoint');
      await this.deletePoint(id);
    },

    // Обновление данных с бекенда
    async handleRefresh() {
      await this.getPoints();
    },

    // Добавление акции
    handleAdd() {
      this.creatigNew = true;
    },

    ...mapActions({
      deletePoint: 'points/deletePoint',
      getPoints: 'points/getPoints',
    }),
  },

  components: {
    KPage,
    KPointEditForm,
    KPointsList,
  },
};
</script>

<style lang="scss">
  .page-points {
    display: flex;
    flex-direction: column;

    &__controls {
      margin-bottom: 24px;
    }

    &__filter {
      margin-bottom: 24px;
    }
  }
</style>
